enum Action {
  UNASSIGN_EMPLOYMENT = 'unassignEmployment',
}

export default Action;
